// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style_warningIcon__27G1s"};